//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  getTradeWay,
  getTradeType,
  getInvoiced,
  getProjectStatus,
} from "@/assets/js/dict";
export default {
  created() {
    getTradeWay().then((res) => {
      this.tradeWayList = res;
    });
    getTradeType().then((res) => {
      this.typeList = res;
    });
    getInvoiced().then((res) => {
      this.invoicedList = res;
    });
    getProjectStatus().then((res) => {
      this.statusList = res;
    });
  },
  data: () => ({
    tradeWayList: [],
    typeList: [],
    invoicedList: [],
    statusList: [],
    type: "1",
    loading: false,
    finished: false,
    list: [],
    form: {
      title: "",
      tradeWay: "",
      pageIndex: 1,
      pageSize: 10,
      sortName: "",
      sortOrder: "",
      startTime: "",
      endTime: "",
    },
    forms: {
      projectName: "",
      pageIndex: 1,
      pageSize: 10,
      sortName: "",
      sortOrder: "ASC",
      title: "",
    },
    info: "",
    infos: "",
    loadings: false,
    finisheds: false,
    lists: [],
  }),
  methods: {
    //切换
    changeT(index) {
      this.type = index;
      if (index == 2) {
        this.getLists();
      }
    },

    //账户信息
    accountInfo() {
      this.$get(
        "/pay/order/userBalance?userId=" + getSession("user").id,
        "",
        function (res) {
          if (res.code == 200) {
            this.info = res.data;
          }
        }
      );
    },

    // 用户信息
    getInfo() {
      this.$get("/sys/user/info", "", function (res) {
        if (res.code == 200) {
          this.infos = res.data;
        } else {
          this.info = "";
        }
      });
    },

    // 提现
    withdraw() {
      this.$get("/sys/user/info", "", function (res) {
        if (res.code == 200) {
          var info = res.data;
          var realName = ''
          if (info.currentUserType == 2) {
            if (info.consumerAuthStatus != 1) {
              this.$confirm("用户发包商身份还未认证", "提示", {
                confirmButtonText: "去认证",
                cancelButtonText: "取消",
                type: "warning",
              }).then(() => {
                this.$router.push({
                  path: "/person/renzheng",
                });
              });
            } else {
                if (info.consumerType == 1) {
                    realName = res.data.userPersonalExpertParam.realName;
                }
                if (info.consumerType == 3) {
                    realName = res.data.userEnterprise.realName;
                }
                this.$router.push({
                    path: "/person/withdraw?realName="+realName,
                });
            }
          }
          if (info.currentUserType == 3) {
            if (info.providerAuthStatus != 1) {
              this.$confirm("用户服务商身份还未认证", "提示", {
                confirmButtonText: "去认证",
                cancelButtonText: "取消",
                type: "warning",
              }).then(() => {
                this.$router.push({
                  path: "/person/renzheng",
                });
              });
            } else {
                if (info.providerType == 1) {
                    realName = info.userPersonalExpertParam.realName;
                }
                if (info.providerType == 2) {
                    realName = info.userStudio.realName;
                }
                if (info.providerType == 3) {
                    realName = info.userEnterprise.realName;
                }
                this.$router.push({
                    path: "/person/withdraw?realName="+realName,
                });
            }
          }
        }
      });
    },
    // 提现详情
    withdrawInfo() {
      this.$router.push({
        path: "/person/withdrawInfo",
      });
    },
    // 余额记录列表
    getList() {
      this.loading = true;
      this.$get("/pay/order/list", this.form, function (res) {
        var newArr = res.data.records;
        if (!newArr || newArr.length === 0) {
          this.finished = true;
        } else {
          this.list.push(...newArr);
          this.form.pageIndex = this.form.pageIndex + 1;
        }
        this.loading = false;
      });
    },

    // 订单列表
    getLists() {
      this.loadings = true;
      this.$get("/tra/project/order/listByUser", this.forms, function (res) {
        var newArr = res.data.records;
        if (!newArr || newArr.length === 0) {
          this.finisheds = true;
        } else {
          this.lists.push(...newArr);
          this.forms.pageIndex = this.form.pageIndex + 1;
        }
        this.loadings = false;
      });
    },

    //申请开票
    applyInvoice(row) {
      this.$router.push({
        path:
          "/person/applyInvoice?invoiceAmount=" +
          row.applyAmount +
          "&ids=" +
          row.payOrderId +
          "&projectName=" +
          row.projectName,
      });
    },

    // 发票详情
    invoiceInfo(row) {
      this.$router.push({
        path: "/person/invoiceInfo?id=" + row.payInvoiceId,
      });
    },
  },
  mounted() {
    this.accountInfo();
    this.getInfo();
  },
};
